import { createFileRoute } from '@tanstack/react-router';
import ApprovalModule from '@/modules/ess/absence/approval/ApprovalModule';

export const Route = createFileRoute('/(dashboard)/_dashboard/ess/absence/$id')({
  component: ApprovalModule,
});
